import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import testimonialImg from "../../assets/images/testimonioal-img.png";
import testimonialImg2 from "../../assets/images/testimonial-img-2.png";
import testimonialImg3 from "../../assets/images/testimonial-img-3.png";
import testimonialImg4 from "../../assets/images/testimonial-img-4.png";

const testimonials = [
  {
    name: "Jamie Bower",
    title: "Casual Learner graduate",
    image: testimonialImg,
    bgClass: "theme-color",
    text: '"I recently explored the new online learning platform, and it was fantastic! The interface is user-friendly, perfect for both relaxing and focused study sessions. I enrolled in a graphic design course, and the content was rich and engaging, just the way I like it. The support team was friendly and attentive, making my learning experience even better. I cant wait to dive into more courses!"',
  },
  {
    name: "Emma Darcy",
    title: "Travel Ready graduate",
    image: testimonialImg2,
    bgClass: "light-periwinkle",
    text: '"I checked out the local coding bootcamp last weekend, and I was blown away by their curriculum! The workshops were interactive and informative, and the project-based learning was to die for. The platform had a lovely community vibe, and the instructors were super helpful. Definitely a must-visit for anyone looking to enhance their tech skills!"',
  },
  {
    name: "Sofia Patel",
    title: "Casual Learner graduate",
    image: testimonialImg3,
    bgClass: "green",
    text: '"I attended a webinar on digital marketing at the new online learning hub, and it was a delightful experience! The presentations were well-structured and packed with valuable insights. I learned about SEO strategies, and the information was bursting with practical tips. The atmosphere was warm and inviting, making it a great spot for networking. Highly recommend!"',
  },
  {
    name: "Liam Fox",
    title: "Intermediate Learner",
    image: testimonialImg4,
    bgClass: "theme-color",
    text: '"Just finished a course on data science at the new e-learning platform, and I’m impressed! The modules were comprehensive and beautifully designed. I loved the hands-on projects, and the instructors were knowledgeable about the subject matter. The community was vibrant, making it a fun learning experience. I’ll definitely be enrolling in more courses!"',
  },
  {
    name: "Liam Fox",
    title: "Intermediate Learner",
    image: testimonialImg4,
    bgClass: "theme-color",
    text: '"Just finished a course on data science at the new e-learning platform, and I’m impressed! The modules were comprehensive and beautifully designed. I loved the hands-on projects, and the instructors were knowledgeable about the subject matter. The community was vibrant, making it a fun learning experience. I’ll definitely be enrolling in more courses!"',
  },
];

const TestimonialSlider = () => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1200, // for screens ≤ 1200px
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024, // ✅ added for 1024px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // tablets & below
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="testimonial-slider py-5 overflow-visible">
      <Slider {...settings}>
        {testimonials.map((item, i) => (
          <div className="testimonial-card pe-49" key={i}>
            <div
              className={`p-4 h-100 d-flex ${
                i % 2 === 0 ? "flex-column" : "flex-column-reverse"
              }`}
            >
              <div className="d-flex align-items-end mb-20 gap-3">
                <LazyLoadImage
                  effect="blur"
                  src={item.image}
                  alt={item.name}
                  className={`testimonial-img ${item.bgClass}`}
                />
                <div>
                  <h6 className="fw-bold mb-5 ah-text-lg">{item.name}</h6>
                  <p className="ah-text-lg fw-normal title mb-0">
                    {item.title}
                  </p>
                </div>
              </div>
              <p className="text-muted testimonial-text">{item.text}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialSlider;
